export const ALL_COUNCIL_POST = "medical_council/list";
export const COUNCIL_DETAILS_GET = "medical_council/detail";
export const DELETE_COUNCIL_POST = "medical_council/delete";
export const ADD_COUNCIL_POST = "medical_council/add";
export const UPDATE_COUNCIL_POST = "medical_council/update";